/** Shared learner UI motion duration (modals, banners, expand/collapse). No imports — safe during circular chunk init. */
export const LEARNER_UI_ANIM_MS = 200;

/** Modal dim and slide. Keep in sync with the modal motion in index.css (180ms). */
export const LEARNER_SIDE_BACKDROP_MS = 180;
